import { render, staticRenderFns } from "./access.vue?vue&type=template&id=0916e93c&scoped=true&"
import script from "./access.vue?vue&type=script&lang=ts&"
export * from "./access.vue?vue&type=script&lang=ts&"
import style0 from "./access.vue?vue&type=style&index=0&id=0916e93c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916e93c",
  null
  
)

export default component.exports